import { createFileRoute, Link, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { AuthShell } from '../components/auth/auth-shell';
import { SignupForm } from '../components/auth/signup-form';
import { useAuthStore } from '../stores/auth-store';

function SignupPage() {
  const { t } = useTranslation();
  return (
    <AuthShell
      title={t('auth.signup.title')}
      subtitle={t('auth.signup.subtitle')}
      footer={
        <div>
          {t('auth.signup.already_have')}{' '}
          <Link to="/login" className="font-medium text-primary hover:underline">
            {t('auth.signup.login_link')}
          </Link>
        </div>
      }
    >
      <SignupForm />
    </AuthShell>
  );
}

export const Route = createFileRoute('/signup')({
  beforeLoad: () => {
    if (useAuthStore.getState().status === 'authenticated') {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: SignupPage,
});
